import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "crm:flex crm:flex-col crm:p-2 crm:rounded-sm bg-light-gray crm:my-2" }
const _hoisted_2 = { class: "crm:flex justify-content-between crm:mb-2" }
const _hoisted_3 = { class: "ps-1" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "mt-2" }
const _hoisted_6 = {
  key: 0,
  class: "crm:flex justify-content-end"
}

import {arrow_answer} from '../../svg/svgs.js'


export default {
  __name: 'Message',
  props: {
  /**
   * autore del messaggio
   */
  autore: {
    type: String,
    default: ''
  },
  /**
   * contenuto del messaggio
   */
  description: {
    type: String,
    default: ''
  },
  /**
   * data di inserimento del messaggio
   */
  dataInserimento: {
    type: String,
    default: null
  },
  /**
   * se true, nasconde la cta di inserimento risposta
   */
  disableCta: {
    type: Boolean,
    default: false
  }
},
  emits: [
  /**
   * emitta l'azione di risposta ad una nota già esistente
   */
  'rispondiNota'
],
  setup(__props, { emit: __emit }) {

/**
 * @doc Si occupa di renderizzare i messaggi delle note legate ai documenti della checklist
 */

const props = __props

const emits = __emit

return (_ctx, _cache) => {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("strong", null, _toDisplayString(__props.autore), 1 /* TEXT */)
      ]),
      (__props.dataInserimento)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "crm:text-secondary",
            innerHTML: `il ${__props.dataInserimento}`
          }, null, 8 /* PROPS */, _hoisted_4))
        : _createCommentVNode("v-if", true)
    ]),
    _renderSlot(_ctx.$slots, "content", {}, () => [
      _createElementVNode("span", _hoisted_5, _toDisplayString(__props.description), 1 /* TEXT */),
      (!__props.disableCta)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("span", {
              class: "crm:shadow-none! crm:cursor-pointer",
              onClick: _cache[0] || (_cache[0] = _withModifiers($event => (emits('rispondiNota')), ["prevent"]))
            }, [
              _createVNode(_component_base_icon, {
                icon: _unref(arrow_answer),
                fill: "#111"
              }, null, 8 /* PROPS */, ["icon"]),
              _cache[1] || (_cache[1] = _createElementVNode("u", { class: "ms-2" }, "Rispondi", -1 /* CACHED */))
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

}